import styled from 'styled-components'

const Titles = styled.div`
  grid-area: ${({ position }) => `titles-${position}`};
  text-align: right;
`

export default Titles
